import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { formatDay } from './journeyTime'
import { relativeDay } from './journeyWords'
import { DayHeader, Muted } from './journeyStyles'

const DayHeaderLine = ({ at, daysBefore, lang }) => {
  const { t } = useTranslation('inquiries')
  return (
    <DayHeader>
      <span>{formatDay(at, lang)}</span>
      <Muted $small style={{ fontWeight: 400 }}>{relativeDay(t, daysBefore)}</Muted>
    </DayHeader>
  )
}

DayHeaderLine.propTypes = {
  at: PropTypes.string.isRequired,
  daysBefore: PropTypes.number.isRequired,
  lang: PropTypes.string.isRequired
}

export { DayHeaderLine }
